import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_14128_541)">
      <path
        opacity={0.3}
        d="M12.7676 8.72853C12.7676 8.99944 12.8752 9.25926 13.0668 9.45083C13.2583 9.6424 13.5182 9.75002 13.7891 9.75002C14.06 9.75002 14.3198 9.6424 14.5114 9.45083C14.7029 9.25926 14.8106 8.99944 14.8106 8.72853C14.8106 8.59438 14.7841 8.46155 14.7328 8.33762C14.6815 8.21368 14.6062 8.10107 14.5114 8.00622C14.4165 7.91137 14.3039 7.83612 14.18 7.78479C14.056 7.73345 13.9232 7.70703 13.7891 7.70703C13.6549 7.70703 13.5221 7.73345 13.3982 7.78479C13.2742 7.83612 13.1616 7.91137 13.0668 8.00622C12.9719 8.10107 12.8967 8.21368 12.8453 8.33762C12.794 8.46155 12.7676 8.59438 12.7676 8.72853Z"
        fill="#3C7BEA"
      />
      <path
        opacity={0.3}
        d="M1.47913 3.92218L13.2887 0.755928C13.2975 0.753604 13.3066 0.75875 13.3091 0.767715L14.5351 5.34078C14.5357 5.34289 14.5358 5.34508 14.5355 5.34724C14.5352 5.3494 14.5345 5.35148 14.5334 5.35336C14.5323 5.35525 14.5309 5.35689 14.5291 5.35821C14.5274 5.35953 14.5254 5.36049 14.5233 5.36104L2.71379 8.52729C2.70952 8.5284 2.70498 8.52779 2.70116 8.52559C2.69733 8.52338 2.69454 8.51975 2.69337 8.5155L1.46734 3.94243C1.46502 3.93363 1.47033 3.92467 1.47913 3.92218Z"
        fill="#3C7BEA"
      />
      <path
        d="M14.8099 6.57436C13.6202 6.0109 12.1989 6.51857 11.6355 7.70841C11.072 8.89808 11.5797 10.3193 12.7695 10.8828C13.0884 11.0338 13.4369 11.1121 13.7897 11.1121C14.1425 11.1121 14.491 11.0338 14.8099 10.8828V12.4742C14.8099 13.2264 14.2001 13.8362 13.4479 13.8362H2.55145C1.79923 13.8362 1.18945 13.2264 1.18945 12.4742V4.30193C1.18945 3.54972 1.79923 2.93994 2.55145 2.93994H13.4479C14.2001 2.93994 14.8099 3.54972 14.8099 4.30193V6.57436Z"
        fill="url(#paint0_linear_14128_541)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_14128_541"
        x1={1.30554}
        y1={3.74707}
        x2={15.026}
        y2={4.08632}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C7BEA" />
        <stop offset={1} stopColor="#3C6DEA" />
      </linearGradient>
      <clipPath id="clip0_14128_541">
        <rect y={0.888184} width={16} height={14.2222} rx={2} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
